import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Clickable from 'components/Common/Clickable'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import interactiveFocusStyle from 'styles/utils/interactiveFocusStyle'

const MerchandiseColourCircle = styled.div<{ size?: number; $hasImage?: boolean }>`
  height: ${props => rem(props.size ?? 16)};
  width: ${props => rem(props.size ?? 16)};
  border-radius: ${props => props.theme.borderRadius.round};
  flex-shrink: 0;
  ${props => props.$hasImage && `
    background-size: cover;
    background-position: center;
  `}
`

const ColourOptionWrapper = styled.div<{ $interactive: boolean; $selected: boolean; $size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => rem(props.$size <= 12 ? 2 : 3)};
  border: 1px solid ${props => props.$selected
    ? props.theme.palette.neutral.default.one
    : props.theme.palette.neutral.default.six};
  border-radius: ${props => props.theme.borderRadius.round};
  transition: ${props => props.$interactive ? 'border-color 0.2s, transform 0.2s' : 'border-color 0.2s'};
  background-color: ${props => props.theme.palette.neutral.default.eight};

  ${mediaHoverable} {
    &:hover {
      transform: ${props => props.$interactive ? 'scale(1.1)' : 'none'};
    }
  }

  &:focus {
    ${props => props.$interactive ? interactiveFocusStyle : ''}
  }
`

const MULTICOLOUR_IMAGE_URL = 'https://images.luxuryescapes.com/82fd1ca1-21e2-4934-a510-15e0e022ccf4'

interface MerchandiseColourOptionProps {
  selected?: boolean
  interactive?: boolean
  size?: number
  onClick?: () => void
  color?: string
  imageUrl?: string
}

export function MerchandiseColourOption(props: MerchandiseColourOptionProps) {
  const { selected = false, interactive = false, size = 16, onClick, color, imageUrl } = props

  // Use multicolour image if no color is provided and no explicit imageUrl is given
  const finalImageUrl = imageUrl || (!color ? MULTICOLOUR_IMAGE_URL : undefined)

  const circleStyle = finalImageUrl
    ? { backgroundImage: `url(${finalImageUrl})` }
    : { backgroundColor: color }

  const content = (
    <ColourOptionWrapper
      $interactive={interactive}
      $selected={selected}
      $size={size}
    >
      <MerchandiseColourCircle size={size} $hasImage={!!finalImageUrl} style={circleStyle} />
    </ColourOptionWrapper>
  )

  if (interactive && onClick) {
    return <Clickable onClick={onClick}>{content}</Clickable>
  }

  return content
}

export default MerchandiseColourOption
